<template>
    <div class="table-box">
        <Table :columns="columns" :data="datas" ref="table"></Table>
    </div>
</template>

<script>
    export default {
        name: "draftBox",
        data(){
            return{
                datas:[],
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title:'ID',
                        key:'id',
                        sortable: true
                    },
                    {
                        title:'发布者',
                        key:'author'
                    },
                    {
                        title:'发布者账号',
                        key:'authorAccount'
                    },
                    {
                        title:'最后编辑时间',
                        key:'endEditTime',
                        sortable: true
                    },
                    {
                        title:'可见班级',
                        key:'class',
                    },
                    {
                        title:'状态',
                        key:'status',
                    },
                    {
                        title:'操作',
                        key:'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            // this.modifyRow(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
            }
        }
    }
</script>
<style scoped lang="less">
    @import "../../style/index";
</style>